// eslint-disable-next-line jsx-a11y/anchor-is-valid
import React, { useState } from 'react';
import { Card, Button, Accordion, Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function WeekendCourse() {
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);

    const navigateToCourses = () => {
        navigate('/contactus');
    }
    const courseDetails = {
        name: "Basic to Intermediate Course",
        // price: "Rs. 4000.00",
        // date: "04 February 2025",
        timing: "10:00 am to 5:00 pm",
        ageCriteria: "16 years & Above",
        whatsappNumber: "9445744663"
    }

    const handleBookNow = () => {
        const message = `Course Name: ${courseDetails.name}%0ATiming: ${courseDetails.timing}%0AQuantity: ${quantity}`;
        const whatsappUrl = `https://wa.me/${courseDetails.whatsappNumber}?text=${message}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Weekend Courses</h1>
                </div>
            </div>
            <div className='diplomaPge'>
                <section>
                    <div className="header-section" style={{ fontFamily: 'DancingScript,cursive' }}>
                        <h1 style={{ fontSize: '28px' }}>Basic to Intermediate Courses</h1>
                    </div>
                </section>

                <Row style={{ margin: '0', padding: '0' }}>
                    <Col md={8} style={{ paddingLeft: "5%", lineHeight: '2.5' }}>

                        {/* Header Section */}
                        <section className="about-course" >
                            <h2>About Course</h2>
                            <p style={{ textAlign: 'justify' }}>The Basic to Intermediate Course is a well-structured
                                one-month program designed to elevate your
                                baking skills from fundamental techniques to
                                professional-level expertise. This course
                                covers a diverse range of baking and pastry-making
                                methods, equipping students with hands-on experience in
                                creating bakery-quality products. Whether you're
                                an aspiring home baker or looking to start
                                a career in baking, this course provides the
                                essential knowledge and practical skills
                                required to master the art of baking.</p>
                        </section>

                        {/* <section className="learn-section">
                            <h2>What Will You Learn?</h2>
                            <ul>
                            <li><strong>Quick Breads & Tea Cakes: </strong> Learn to make flavorful cupcakes, muffins, and tea cakes with perfect textures and delicious fillings.</li>
                                <li> <strong>Cookies & Tarts: </strong>Master the techniques for creating classic cookies and tarts, including chocolate chip cookies, biscotti, apple pie, and coffee chocolate tart.</li>
                                <li><strong>Breads & Viennoiseries:</strong> Gain hands-on experience in making soft dinner rolls, burger buns, puff pastries, croissants, and breakfast pastries.</li>
                                <li><strong>Cakes & Sponges:</strong> Develop skills in baking different types of sponges and fillings, along with professional frosting techniques.</li>
                                <li><strong>Custards & Classic Desserts:</strong> Explore timeless desserts such as crème brûlée, opera cake, chocolate lava cake, and New York cheesecake.</li>
                                <li><strong>Basic Chocolate & Confectionery:</strong> Learn the art of making bonbons, hand-rolled truffles, and chocolate decorations.</li>
                            </ul>
                        </section> */}

                        {/* <section>
                            <h2>Who Should Enroll?</h2>
                            <p>This diploma is ideal for individuals who want to pursue a professional career in the bakery and pastry arts. Whether you are a beginner with a passion for baking or a culinary professional seeking to expand your expertise, this course offers the perfect balance of theory and hands-on practice.
                            </p>
                        </section> */}
                        {/* What Will You Learn Section */}
                        <section className="learn-section">
                            <h2>Course Features:</h2>
                            <ul>
                                <li>Taught by experienced pastry chefs and industry professionals.</li>
                                <li>State-of-the-art facilities with professional-grade equipment.</li>
                                <li>Opportunities for internships and real-world experience.</li>
                                <li>Small class sizes for personalized learning.</li>
                                <li>Certification recognized by the culinary industry.</li>
                            </ul>
                        </section>

                        <section className="about-course" >
                            <h2>Certification</h2>
                            <p style={{ textAlign: 'justify' }}>Our Basic to Intermediate program is affiliated with the Council for Vocational Education and Development (CVESD), a government-approved organization. Upon successful completion, students will receive:</p>
                            <ul>
                                <li>A certificate from Finesse Academy for Bakery and Pastry Arts.</li>
                                <li>A certificate from CVESD (Counsil for Vocational Education and Skill Development).</li>
                            </ul>
                        </section>

                        {/* <section className="learn-section">
                            <h2>Certification</h2>
                            <ul>
                                <li>This dual certification ensures our students meet industry standards and are well-prepared for a successful career in bakery and pastry arts.</li>
                            </ul>
                        </section> */}


                        {/* Course Curriculum Section */}
                        <section className="curriculum-section">
                            <h2>Course Curriculum</h2>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header> Quick Breads</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Cupcakes: Vanilla and lemon curd cupcake, chocolate cupcake with ganache cream, red velvet cupcake with cream cheese frosting.</li>
                                            <li>Muffins: Berry muffin, coconut muffin, chocolate chip muffin, savory pizza muffin.</li>
                                            <li>Tea Cakes: Banana and chocolate chip cake with milk chocolate ganache, lemon cake with lime ginger glaze, carrot cake with cream cheese frosting.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Cookies and Tarts</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Cookies: Chocolate chip cookies, oats and raisin cookies, whole wheat jeera cookies, chocolate almond biscotti, strawberry jam drop cookies, classic chocolate brownie.</li>
                                            <li>Tarts: Coconut lime tart, apple pie, coffee chocolate tart, red berry tart.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Breads and Viennoiseries</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Breads: Dinner rolls (soft and hard), Korean cheese bun, burger buns, sandwich bread.</li>
                                            <li>Puff Pastry: Puff dough, lamination methods, egg curry puff, millefeuille, cheese straw, palmier, vegetable jalousie.</li>
                                            <li>Croissants & Breakfast Pastries: Croissant dough and lamination methods, butter croissant, almond croissant, pain au chocolat, fruit Danish, chocolate babka.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Cakes and Sponges</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Sponges: Vanilla genoise sponge, vanilla eggless sponge, chocolate eggless sponge, red velvet sponge.</li>
                                            <li>Fillings: Fresh fruit compote, cherry compote, white chocolate Chantilly, cream cheese filling, mocha ganache cream.</li>
                                            <li>Frostings: Italian meringue buttercream, chocolate ganache, cream cheese frosting, whipping cream, chocolate mirror glaze.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Custards and Classic Desserts</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Custards: Crème caramel, bread and butter pudding, pot de crème, crème brûlée.</li>
                                            <li>Classic Desserts: French opera cake, red velvet roulade, New York cheesecake, baklava, chocolate lava cake, berry choux, chocolate éclair.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Basic Chocolate & Confectioneries</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>Bonbons: Soft caramel, berry ganache, coffee ganache.</li>
                                            <li>Confectioneries: Hand-rolled truffles (white, dark, and milk chocolate), chocolate decorations and garnishes.</li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </section>
                    </Col>
                    <Col md={4}>
                        {/* Sidebar Section */}
                        <div className="course-sidebar">
                            <Card className="sidebar-card">
                                <Card.Body>
                                    {/* YouTube Video */}
                                    <div className="video-container">
                                        <img src='images/dessertoutside.jpg' style={{ width: '100%' }} />
                                    </div>

                                    {/* Pricing */}
                                    <p className="course-price">₹ 28,320<br />
                                        <span className='course-amt'>  (Inclusive of 18% GST and CVESD Certificate Charges)</span></p>

                                    {/* <button onClick={navigateToCourses} className="add-to-cart">Enrol Now</button> */}
                                    {/* <Button variant="outline-primary" className="buy-course" block>Buy Course</Button> */}

                                    {/* <hr className="course-divider" /> */}
                                    &nbsp;
                                    {/* Course Details */}
                                    <ul
                                        className="course-includes"
                                    >
                                        <p><strong>Duration:</strong></p>
                                        <p className="age">1 Month</p>
                                        <p><strong>Schedule:</strong></p>
                                        <p className="age">Weekend (Saturday & Sunday)</p>
                                        <p><strong>Age Criteria:</strong> </p>
                                        <p className="age">{courseDetails.ageCriteria}</p>
                                        <p><strong>Timing:</strong></p>
                                        <p className="timing"> {courseDetails.timing}</p>



                                        <Form.Group>
                                            <Form.Label><strong>Quantity</strong></Form.Label>
                                            <div className="quantity-controls">
                                                <button onClick={() => setQuantity(quantity > 1 ? quantity - 1 : 1)} className="quantity-btn">
                                                    −
                                                </button>
                                                <span className="quantity-display">{quantity}</span>
                                                <button onClick={() => setQuantity(quantity + 1)} className="quantity-btn">
                                                    +
                                                </button>
                                            </div>
                                        </Form.Group>

                                        <button className="add-to-cart" onClick={handleBookNow} style={{ background: 'black' }}>
                                            Book Now
                                        </button>
                                        {/* <li><strong>Duration:</strong> 2 months</li>
                                        <li><strong>Schedule: </strong> 5 days a week</li>
                                        <li><strong>Timing: </strong> 10.00 am-5.00 pm</li>
                                       
                                        <li><strong>Certificate:</strong> Yes</li> */}
                                    </ul>
                                    {/* <Button  className="share-course">Share this course</Button> */}
                                </Card.Body>

                            </Card>
                        </div>
                    </Col>
                </Row>
                {/* About Course Section */}
            </div>

        </>
    )
}